import { appStore } from '@kaltura-ott/tvpil-shared';

export function getKS(): string {
  return appStore.loginStore.ks;
}
